import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BusinessTyesService } from '../../services/business-tyes.service';
import { FormBuilder, FormGroup, Validators, AbstractControl, NgForm } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-select-profession-type',
  templateUrl: './select-profession-type.component.html',
  styleUrls: ['./select-profession-type.component.scss']
})
export class SelectProfessionTypeComponent implements OnInit {

type:any;
enterData:any;
selectedForm: FormGroup;
dataForm = {
  name:null,
  id:null
 // other
}

profForm = {
  name:null,
  directory_business_type_id:null
  
}


busineessTypes:any;
userProf:any;
othersTypes:any;
newDirCat:any;
myVal = {
  name:null
}
//private data: string;
    @Output() emitService = new EventEmitter();
  constructor(
    private _dialogRef: MatDialogRef<SelectProfessionTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private _dialog: MatDialog,
    private businessTyesService:BusinessTyesService,
    private _fb: FormBuilder
  ) { 
    console.log('mg mangal', data);
  }

  ngOnInit(): void {

   this.myVal.name =  localStorage.getItem('userProf');

   //console.log(one)

  

    // this.businessTyesService.getOthersTypes("others").subscribe(data=>{
      
    //   this.othersTypes = data[0]
    //   console.log(this.othersTypes)

      
    // });
    
    this.type = this.data
    this.businessTyesService.getBusinessTYpes(this.type).subscribe(data=>{
      console.log(data)
      this.busineessTypes = data
    })

    this.selectedForm = this._fb.group({
      selEnterData: [null],
      formData:[null]
     
      //type: [null, [Validators.required]]
    });

    console.log(this.myVal.name);

    this.selectedForm.patchValue({

      selEnterData:this.myVal.name
  
     })

  }


  selMainData(){
    console.log( this.selectedForm.value)

    this.dataForm.name = this.selectedForm.value.formData

    if(this.selectedForm.value.formData){
     console.log('rk test case');
      localStorage.setItem('userProf', this.selectedForm.value.formData);

      this.profForm.name = this.dataForm.name
      if(this.othersTypes?.id != undefined)
          this.profForm.directory_business_type_id = this.othersTypes.id
      
     
      this.businessTyesService.addNewProfession(this.profForm).subscribe(data=>{
        console.log(data)
        this.newDirCat = data
         this.dataForm.id = this.newDirCat.id
          console.log(this.dataForm)
         this.businessTyesService.updatedDataSelection(this.dataForm);
      })
      // this.businessTyesService.addNewProfession(this.profForm)(data=>{
      //   console.log(data)
        

     

      // })
      
    }else{
      console.log(this.userProf)
      localStorage.setItem('userProf', this.userProf.name);
      // for(let single of this.othersTypes.directory_categories){

      //   if(this.userProf.id == single.id){
      //     this.userProf.otherName = "otherCat"
      //   }

      // }
      
      this.businessTyesService.updatedDataSelection(this.userProf);

    }

     // console.log(obj)
    
    // console.log( this.selectedForm.value)
    // this.businessTyesService.updatedDataSelection(this.selectedForm.value);

    // console.log(this.selectedForm.value)

    // this.emitService.next(this.selectedForm.value)
    this._dialogRef.close();
  }
  dialogClose() {
    // this._dialogRef.close();
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }


  

  selectedData(selData){   
    this.userProf = selData
  }

  // selectedDataCustom (event: MatTabChangeEvent) {
  //   const ind = event.index;
  //   const busiType = this.data[ind]
  //   console.log('hi therre...', busiType);
  //   if(busiType.directory_categories.length == 0) {
  //     this.selectedData({id: busiType.id, name: busiType.name, __typename: busiType.__typename});
  //     this.selectedForm.patchValue({
  //       selEnterData: busiType.name
  //     })
  //   } else {
  //     this.selectedData(null);
  //     this.selectedForm.patchValue({
  //       selEnterData: null
  //     })
  //   }
  // }

}
